// extracted by css-extract-rspack-plugin
export default {"marker":"Ep2_KZd68UPg5fv9"};